// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"efd2ad33","453":"81faba5d"}[chunkId] + ".chunk.js";
};